import styles from './EditTextMenu.module.scss'
import { useDispatch } from 'react-redux'
import { TrashIcon, TableIcon } from '@phosphor-icons/react'
import { ScoopButton, ScoopTooltip } from '../../ui'
import { ReorderPicker } from '../components/ReorderPicker/ReorderPicker'
import { deleteTextEditor, setTextEditorTableRange } from '../../../store/actions'
import { useModal, MODALS } from '../../modals'

export const EditTextMenu = ({ textEditor, handleDelete, workspaceID }) => {
    const dispatch = useDispatch()
    const deleteModal = useModal(MODALS.COMMON.DELETE)
    const selectRangeModal = useModal(MODALS.CANVAS.SELECT_RANGE)

    const handleDeleteClick = async () => {
        const confirmed = await deleteModal.show({
            title: 'TextEditor',
            description: 'Are you sure you want to delete this text object?',
        })
        if (confirmed) {
            handleDelete()
            dispatch(deleteTextEditor(textEditor.id))
        }
    }

    const handleFillClick = async () => {
        await selectRangeModal.show({
            workspaceID,
            worksheetID: textEditor?.worksheetID,
            namedRange: textEditor?.namedRange,
            fitGridToData: textEditor.fitData,
            onConfirm: (worksheet, selectedWorksheetRange, fitData) => {
                dispatch(
                    setTextEditorTableRange(
                        textEditor.id,
                        worksheet.worksheetID,
                        selectedWorksheetRange,
                        fitData
                    )
                )
            },
        })
    }

    return (
        <div className={styles.textEditorMenu} id={'textEditor-menu'}>
            <div className={styles.menuContent}>
                {textEditor.tableShape && (
                    <ScoopTooltip text={'Fill table with data from LiveSheet range'}>
                        <ScoopButton
                            variant="text"
                            onClick={handleFillClick}
                            className={styles.iconButton}
                        >
                            <TableIcon size={20} weight="bold" className={styles.icon} />
                        </ScoopButton>
                    </ScoopTooltip>
                )}
                <ReorderPicker origin={'top'} objectId={textEditor.id} tooltip />
                <ScoopButton
                    variant="text"
                    onClick={handleDeleteClick}
                    className={styles.iconButton}
                >
                    <TrashIcon size={20} weight="bold" className={styles.deleteIcon} />
                </ScoopButton>
            </div>
        </div>
    )
}
